export default "__VITE_ASSET__CgqsZWNj__"